export default {
    property: {},
}
